import { useEffect } from "react";
import { useCallbackRef } from "./use-callback-ref";

/**
 * Uses an event listener.
 */
export function useEventListener(eventType, callback) {
  let el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  let options = arguments.length > 3 ? arguments[3] : undefined;
  const savedCallback = useCallbackRef(callback);
  useEffect(() => {
    const listener = event => savedCallback(event);
    el?.addEventListener(eventType, listener, options);
    return () => el?.removeEventListener(eventType, listener, options);
  }, [eventType, el, options]);
}